export const ladgerJson = {
  screenTitle: "Ledger",
  showAddButton: false,
  showPdfDownload: true,
  pdfFileName: "SalesExecutive",
  showExcelDownload: false,
  excelFileName: "SalesExecutive",
  fieldMeta: [
    {
      label: "Search By",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      getListId: "flag",
      dataKey: "flag",
      tableDataKey: "Outlet wise",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Outlet wise",
          value: "0",
        },
        {
          label: "Sales Person wise",
          value: "1",
        },
      ],
      isMandatory: true,
    },
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 4,
      labelMD: 4,
      labelLG: 4,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "fromdate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 4,
      labelMD: 4,
      labelLG: 4,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 4,
      labelMD: 4,
      labelLG: 4,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      masterName: "areaDetail",
      dataKey: "area",
      getListFrom: "taluka",
      getListId: "area",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Beat ",
      controlType: "multiSelect",
      placeHolder: "Select Beat",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 4,
      labelMD: 4,
      labelLG: 4,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      masterName: "beatDetail",
      dataKey: "beat",
      getListFrom: "area",
      isRootLevelKey: false,
      isMandatory: true,
      getListId: "beat",
    },
    {
      label: "Outlet",
      controlType: "autocomplete",
      placeHolder: "Select Outlet",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "outletIds",
      masterName: "outletDetail",
      getListFrom: "beat",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
  fieldMetaBySalsPerson: [
    {
      label: "Search By",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      getListId: "flag",
      dataKey: "flag",
      tableDataKey: "Outlet wise",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Outlet wise",
          value: "0",
        },
        {
          label: "Sales Person wise",
          value: "1",
        },
      ],
      isMandatory: true,
    },
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 4,
      labelMD: 4,
      labelLG: 4,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "fromdate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 4,
      labelMD: 4,
      labelLG: 4,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
    },
    {
      label: "Area",
      controlType: "multiSelect",
      placeHolder: "Select Area",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 4,
      labelMD: 4,
      labelLG: 4,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      masterName: "areaDetail",
      dataKey: "area",
      getListFrom: "taluka",
      getListId: "area",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Beat ",
      controlType: "multiSelect",
      placeHolder: "Select Beat",
       md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      labelSM: 4,
      labelMD: 4,
      labelLG: 4,
      valueSM: 8,
      valueMD: 8,
      valueLG: 8,
      masterName: "beatDetail",
      dataKey: "beat",
      getListFrom: "area",
      isRootLevelKey: false,
      isMandatory: true,
      getListId: "beat",
    },
    {
      label: "Sales person",
      controlType: "autocomplete",
      placeHolder: "Select Sales Person",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "salesPersonIds",
      getListFrom: "beat",
      masterName: "salesPersonDetail",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
};
